import React from "react";

const GoogleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        d="M14.9306 6.34674L14.8445 6.01863H7.72775V8.98101H11.9844C11.7469 9.885 11.2069 10.6848 10.4508 11.2524C9.69471 11.82 8.76618 12.1227 7.81384 12.1121C6.57108 12.1021 5.37706 11.6373 4.46589 10.8091C4.01799 10.3764 3.66156 9.86138 3.41698 9.29356C3.17242 8.72574 3.04453 8.1162 3.04064 7.49982C3.05509 6.2619 3.55519 5.07689 4.4372 4.19059C5.3355 3.35659 6.52861 2.89624 7.76601 2.90627C8.82578 2.91427 9.84613 3.30093 10.6357 3.99373L12.7401 1.87506C11.3531 0.662321 9.55783 -0.00541513 7.69905 0.000134649C6.6765 -0.00581824 5.66284 0.185668 4.71582 0.563672C3.76881 0.941666 2.90704 1.49877 2.17974 2.20317C0.796266 3.6115 0.0162738 5.48598 0.000251489 7.44085C-0.0157612 9.39574 0.733431 11.2822 2.09365 12.7121C2.84726 13.4479 3.74296 14.0292 4.72839 14.4219C5.71382 14.8147 6.76919 15.0111 7.83297 14.9995C8.79756 15.0066 9.75363 14.8216 10.6432 14.4558C11.5327 14.09 12.3372 13.551 13.0079 12.8715C14.324 11.4532 15.036 9.59477 14.9976 7.67794C15.0079 7.2332 14.9855 6.78838 14.9306 6.34674Z"
        fill="white"
      />
    </svg>
  );
};

export default GoogleIcon;
